/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";

import useApi from "../api";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";
import { IOptionTree } from "./interfaces/IOptionTree";
import { IOptions } from "./interfaces/IOptions";

export const useTPClientService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();

  async function getOptionTree(
    idTree: any
  ): Promise<IApiResponse<IOptionTree | any>> {
    try {
      const response = await api.get(`/TPClient/OptionTree/${idTree}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function getOptions(
    idTree: any
  ): Promise<IApiResponse<IOptions | any>> {
    try {
      const response = await api.get(`/TPClient/TreeOption/${idTree}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
 
  async function getOptionTreeParameters(
    idTree: any,
    parameters: any
  ): Promise<IApiResponse<IOptionTree | any>> {
    try {
      const response = await api.get(
        `/TPClient/OptionTree/${idTree}/${parameters}`
      );
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  return {
    getOptionTree,
    getOptions,
    getOptionTreeParameters,
  };
};
